import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Help from "./Help";
import FreshDesk from "./FreshDesk";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/help" element={<Help />} />
          <Route path="/freshdesk" element={<FreshDesk />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
